<template>
  <div class="ws-title textPrimary--text">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../assets/scss/ws-title.scss";
</style>